<template>

  <v-dialog v-model="dialog" scrollable width="800px" style="z-index: 200000">
    <v-card>

      <v-card color="transparent" flat>
        <v-card-text class="font-weight-light text-xs-left title underlineheadline bluetext">
          {{title}}
        </v-card-text>
      </v-card>
      <v-card-text :key="myKey">
        <PlaylistItem ref="editor" :propItem="item"></PlaylistItem>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="doCancel()" color="red darken-4" small dark outlined class="radiusBtn text-none">Abbrechen</v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="doSave()" color="green darken-3" small dark outlined class="radiusBtn text-none">Speichern
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  //import Vue from 'vue'
  import PlaylistItem from '@/components/module/playlistItem/PlaylistItemDefault.vue'
  export default {
    name: 'DialogItemSettings',
    components: {PlaylistItem},
    methods: {
      /**
       * newName, title, type
       * @param cardConfig
       */
      doCancel: function () {
        this.dialog = false
        this.$emit('cancel', null)
      },
      doSave: function () {
        this.$refs.editor.updateItem()
        this.dialog = false
        this.$emit('save', {})
        this.item = null
        this.$emit('onClose', {})
      },
      open: function (cardConfig, item) {
        this.item = item
        if ((cardConfig != null) && (cardConfig)) {
          this.title = cardConfig.title
          this.description = cardConfig.description
        }
        this.dialog = true
        this.myKey = this.myKey + 1
        this.$refs.editor.onGetData(item)
      }
    },
    data () {
      return {
        myKey: 0,
        item: {},
        title: 'Login nicht erfolgreich',
        description: 'Wir konnten die Kombination aus Username und Passwort nicht validieren',
        dialog: false
      }
    },
    mounted () {
    }
  }
</script>

<style scoped>

</style>
